<script>
	import "../app.css";
	import { computePosition, autoUpdate, offset, shift, flip, arrow } from '@floating-ui/dom';
	import { storePopup } from '@skeletonlabs/skeleton';
	import { Toaster } from "svelte-french-toast";
	
	storePopup.set({ computePosition, autoUpdate, offset, shift, flip, arrow });
</script>

<Toaster
	toastOptions={{
		style: "background: #fff; color: #EC5B4E;",
		position: "bottom-center",
		duration: 3500
	}}
/>

<main class="bg-whitey font-sans h-full w-full m-auto">
	<slot />
</main>
